import { useEffect, useMemo, useState } from "react"
import { Input, Button, Table, Space, Select, DatePicker, Modal, Form, Radio, TreeSelect } from 'antd'
import { RadioChangeEvent } from "antd/lib/radio/interface"
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable, baseAxiosComplete, baseAxiosNoInfo } from "../../tool/axios"
import { SelectStores } from "../../component/common/Selects"
import { CheckImgs } from "../../component/common/Imgs"
import BreadCrumb from '../../component/BreadCrumb'
import getPermission from '../../js/permission'
import moment from "moment"
import _ from 'lodash'

const { Column } = Table
const { Option } = Select
const { RangePicker } = DatePicker

const formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 12 }
}

type fetchParams = {
    customer_name: string | undefined,
    contact_way: string | undefined,
    channel_id: string | undefined,
    init_sales_name: string | undefined,
    follow_sales_name: string | undefined,

    deal_store_id: string[] | undefined,
    deal_item_id: string | undefined,

    review_status: undefined,
    create_user_name: string | undefined,
    date: any
}

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: boolean
}

type fromItem = {
    id: string,
    channel_name: string
}

type project = {
    id: string
    item_name: string
}

export default function () {

    let fetchOtherParamsTmpl: fetchParams = {
        customer_name: undefined,
        contact_way: undefined,
        channel_id: undefined,
        init_sales_name: undefined,
        follow_sales_name: undefined,

        deal_store_id: undefined,
        deal_item_id: undefined,

        review_status: undefined,
        create_user_name: undefined,
        date: null
    }

    const [activeRecord, setActiveRecord] = useState<{ id: string, no_yet_pay_amount?: number, user_name?: string, pay_date?: string, pay_code?: string } | undefined>()
    const [form] = Form.useForm()
    const [urls, setUrls] = useState<string[]>([])

    const [swiperVisible, setSiperVisible] = useState<boolean>(false)
    const [confrimMoneyVisible, setConfrimMoneyVisible] = useState<boolean>(false)

    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)
    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: true
    })

    const [initDate, setInitDate] = useState<boolean>(true)

    const [data, setData] = useState<any>([])
    const [passType, setPassType] = useState<number | undefined>(undefined)

    const [fromItemData, setFromItemData] = useState<fromItem[]>([])
    const [selectNameData, setSelectNameData] = useState<project[]>([])

    const [loading, setLoading] = useState<boolean>(false)

    const permission: string[] = useMemo(() => {
        return getPermission()
    }, [window.location.pathname])

    useEffect(() => {
        if (initDate) {
            var startDate = moment().startOf('month');
            var endDate = moment().endOf('month');
            // 初始化创建日期
            fetchOtherParams.date = [startDate, endDate];

            setInitDate(false)
        }

        fetch({ pagination, fetchOtherParams })
    }, [pagination.current, pagination.pageSize])

    useEffect(() => {
        // 查询渠道来源列表
        baseAxiosNoInfo('/finance_center/global/channel_source_list').then((res: any) => {
            res && setFromItemData(res)
        })

        // 查询套餐项目
        baseAxiosNoInfo('/global/item_list', { params: { item_type: 3 } }).then((res: any) => {
            res && setSelectNameData(res)
        })
    }, [])

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const handleSearch = () => {
        const p = { ...pagination }
        p.current = 1

        fetch({ pagination: p, fetchOtherParams })
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current
        p.pageSize = antPagination.pageSize

        setPagination(p)
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        setLoading(true)

        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        let params: any = { ...fetchOtherParams }
        if (params.date) {
            params.start_create_date = params.date[0].format('YYYY-MM-DD')
            params.end_create_date = params.date[1].format('YYYY-MM-DD')

            delete params.date
        }

        if (params.deal_store_id) {
            params.deal_store_id = params.deal_store_id.join(',')
        }

        axiosTable.get('/finance_center/contract_change/page_list', {
            params: {
                ...iPagination,
                ...params
            }

        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total

                setPagination(p)
                setData(response.records)
            }

            setLoading(false)
        })
    }

    const resetForm = () => {
        setInitDate(false)
        setFetchOtherParams(fetchOtherParamsTmpl)

        let p: any = { ...pagination }
        p.current = 1
        setPagination(p)

        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    const exportExcel = () => {
        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total
        delete iPagination.showSizeChanger

        let params: any = { ...fetchOtherParams }
        if (params.date) {
            params.start_create_date = params.date[0].format('YYYY-MM-DD')
            params.end_create_date = params.date[1].format('YYYY-MM-DD')

            delete params.date
        }

        if (params.deal_store_id) {
            params.deal_store_id = params.deal_store_id.join(',')
        }

        baseAxiosComplete('/finance_center/contract_change/excel', {
            params: {
                ...iPagination,
                ...params
            }

        }).then(res => {
            if (res.status === 0) {
                window.open(res.data)
            }
        })
    }

    const recursionChildren = (children: any[]) => {
        let childArr: any = []

        children.forEach((el: any) => {
            childArr.push({
                title: el.channel_name,
                value: el.id,
                key: el.id,
                children: el.children && recursionChildren(el.children)
            })
        })

        return childArr
    }

    const handlePassChange = (e: RadioChangeEvent) => {
        setPassType(e.target.value)
    }

    // 审核
    const onFinish = (value: any) => {
        baseAxiosComplete.post('/finance_center/contract_change/review', {
            contract_change_id: activeRecord?.id,
            review_status: value.review_status,
            review_refuse_reason: value.review_refuse_reason

        }).then((res: any) => {
            if (res.status === 0) {
                fetch({ pagination, fetchOtherParams })
                setConfrimMoneyVisible(false)
            }
        })
    }

    let ItemNameOptions = selectNameData.map((el: any) => (<Option value={el.id} key={el.id}>{el.item_name}</Option>))

    return (<div className="common-page">
        {/* 财务中心 -> 财务管理 -> 月子合同变更 */}
        <BreadCrumb position={['财务中心', '月子合同变更']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <div style={{ marginRight: 8, marginBottom: 12 }}>
                    <SelectStores multiple showSearch placeholder="签单门店" value={fetchOtherParams.deal_store_id} onChange={(v: string[]) => { handleChange(v, 'deal_store_id') }} />
                </div>
                <Select className="fl" virtual={false} style={{ marginRight: 8, marginBottom: 12, width: 180 }} placeholder="签单套餐" value={fetchOtherParams.deal_item_id} onChange={(v: string) => { handleChange(v, 'deal_item_id') }}>
                    {ItemNameOptions}
                </Select>

                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="客户姓名" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'customer_name') }} value={fetchOtherParams.customer_name} />
                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="联系方式" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'contact_way') }} value={fetchOtherParams.contact_way} />
                <TreeSelect className="fl" style={{ marginRight: 8, marginBottom: 12, width: 160 }} value={fetchOtherParams.channel_id} virtual={false} treeData={recursionChildren(fromItemData)} placeholder="来源渠道" onChange={(v: any) => {
                    handleChange(v, 'channel_id')
                }}
                />
                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="初始销售" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'init_sales_name') }} value={fetchOtherParams.init_sales_name} />
                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="跟进销售" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'follow_sales_name') }} value={fetchOtherParams.follow_sales_name} />

                <RangePicker className="fl" style={{ marginRight: 8, marginBottom: 12, width: 250 }} placeholder={["创建开始日期", "创建结束日期"]} value={fetchOtherParams.date} onChange={(v: any) => { handleChange(v, 'date') }} />
                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="创建人" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'create_user_name') }} value={fetchOtherParams.create_user_name} />

                <Select className="fl" style={{ marginRight: 8, marginBottom: 12, width: 120 }} placeholder="审核结果" value={fetchOtherParams.review_status} onChange={(v: number) => { handleChange(v, 'review_status') }}>
                    <Option value={0} key={0}>待审核</Option>
                    <Option value={1} key={2}>审核通过</Option>
                    <Option value={2} key={2}>审核不通过</Option>
                </Select>
            </Space>

            <div style={{ marginTop: 10 }}>
                <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn fl" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={() => { exportExcel() }} type="dashed" >导出</Button>
            </div>
        </div>

        <div className="common-main">
            <Table loading={loading} dataSource={data} scroll={{ x: 'max-content' }} bordered={true} rowKey="contract_change_id" pagination={pagination} onChange={handleTableChange}>
                <Column fixed title="客户姓名" dataIndex="customer_name" key="customer_name" />
                <Column fixed title="联系方式" dataIndex="contact_way" key="contact_way" />
                <Column fixed title="签单门店" dataIndex="deal_store_name" key="deal_store_name" />
                <Column fixed title="套餐名称" dataIndex="deal_item_name" key="deal_item_name" />

                <Column title="原套餐天数" width={75} dataIndex="before_item_days" key="before_item_days" />
                <Column title="新套餐天数" width={75} dataIndex="after_item_days" key="after_item_days" />
                <Column title="原赠送天数" width={75} dataIndex="before_gift_days" key="before_gift_days" />
                <Column title="新赠送天数" width={75} dataIndex="after_gift_days" key="agreement_amount" />
                <Column title="原护理模式" width={75} dataIndex="before_nursing_care_type" key="before_nursing_care_type" />
                <Column title="新护理模式" width={75} dataIndex="after_nursing_care_type" key="after_nursing_care_type" />
                <Column title="原合同金额" width={75} dataIndex="before_agreement_amount" key="before_agreement_amountcc" />
                <Column title="新合同金额" width={75} dataIndex="after_agreement_amount" key="after_agreement_amount" />

                <Column title="原合同凭证" width={75} dataIndex="before_deal_prov_pic_list" key="before_deal_prov_pic_list" render={(v: any) => {
                    return <Button onClick={() => {
                        setUrls(v)
                        setSiperVisible(true)
                    }} size="small" >查看</Button>
                }} />
                <Column title="新合同凭证" width={75} dataIndex="after_deal_prov_pic_list" key="after_deal_prov_pic_list" render={(v: any) => {
                    return <Button onClick={() => {
                        setUrls(v)
                        setSiperVisible(true)
                    }} size="small" >查看</Button>
                }} />

                <Column title="来源渠道" dataIndex="channel_name" key="channel_name" />
                <Column title="初始销售" width={75} dataIndex="init_sales_name" key="init_sales_name" />
                <Column title="跟进销售" width={75} dataIndex="follow_sales_name" key="follow_sales_name" />
                <Column title="创建人" dataIndex="create_user_name" key="create_user_name" />
                <Column title="创建时间" dataIndex="create_time" key="create_time" />
                <Column title="审核状态" dataIndex="review_status_desc" key="review_status_desc" />

                <Column
                    title="操作"
                    key="action"
                    render={(text, record: any) => {
                        return (<Space size="middle">
                            {record.review_status === 0 && permission.includes('审核') && <Button onClick={() => {
                                form.setFieldsValue({
                                    review_status: undefined,
                                    review_refuse_reason: undefined,
                                })

                                setPassType(undefined)
                                setConfrimMoneyVisible(true)
                                setActiveRecord({ id: record.contract_change_id })
                            }} size="small" >审核</Button>}
                        </Space>)
                    }}
                />
            </Table>
        </div>

        {/* 审核弹窗 */}
        <Modal title="合同变更审核" visible={confrimMoneyVisible} footer={false} onCancel={() => { setConfrimMoneyVisible(false) }}>
            <Form {...formItemLayout} form={form} onFinish={onFinish} >
                <Form.Item label="是否通过" name="review_status" rules={[{ required: true, message: '必须选择是否通过审核' }]}>
                    <Radio.Group onChange={handlePassChange} value={passType}>
                        <Radio value={1}>通过</Radio>
                        <Radio value={2}>不通过</Radio>
                    </Radio.Group>
                </Form.Item>

                {passType === 2 && <Form.Item label="备注" name="review_refuse_reason" rules={[{ required: true, message: '必须填写备注' }]}>
                    <Input />
                </Form.Item>}

                <Form.Item wrapperCol={{ span: 12, offset: 6 }}>
                    <Button type="primary" htmlType="submit">提交</Button>
                </Form.Item>
            </Form>
        </Modal>

        <CheckImgs tinyURL={urls} visible={swiperVisible} onCancel={() => { setSiperVisible(false) }} />
    </div>)
}